@if (requestDataLoaded) {
    @if (requestData) {
        <div class="content">
            <form action="" method="post" [formGroup]="resetPasswordForm">
                <div class="inputGroup">
                    <span class="label">{{ 'forgotPassword.emailAddress' | translate }}</span>
                    <span class="label" id="email">{{ requestData.email }}</span>
                </div>

                <div class="inputGroup labelTop">
                    <label for="password">{{ 'forgotPassword.newPassword' | translate }}</label>
                    <app-form-error [parentForm]="resetPasswordForm" [controlPath]="'newPassword'" />
                    <div class="inputWrapper">
                        <app-password-input [id]="'newPassword'" formControlName="newPassword" />
                    </div>
                </div>

                <div class="inputGroup confirmPasswordContainer">
                    <label for="confirmPassword">{{ 'forgotPassword.confirmPassword' | translate }}</label>
                    <app-form-error [parentForm]="resetPasswordForm" [controlPath]="'confirmPassword'" />
                    <div class="inputWrapper">
                        <app-password-input [showHints]="false" [id]="'confirmPassword'" formControlName="confirmPassword" />
                    </div>
                </div>

                <app-form-error [parentForm]="resetPasswordForm" />
                <div class="buttonArea">
                    <button
                        class="button primary"
                        type="submit"
                        id="reset"
                        [title]="'forgotPassword.emailAddress' | translate"
                        (click)="resetPassword()"
                    >
                        {{ 'forgotPassword.resetPassword' | translate }}
                    </button>
                </div>
            </form>
        </div>
    } @else {
        <h3>{{ 'forgotPassword.expiredPasswordResetRequest' | translate }}</h3>
    }
}
